import axiosApi from "@client-shared/lib/axiosApi";

export * from "./admin-product";
export * from "./auth";
export * from "./batches";
export * from "./config";
export * from "./connection";
export * from "./featureFlags";
export * from "./installations";
export * from "./orders";
export * from "./payout";
export * from "./product";
export * from "./service";
export * from "./taxConfig";
export * from "./userProfile";
export * from "./ss-roaster-products";

if (!process.env.REACT_APP_API_HOST) {
  throw new Error(`REACT_APP_API_HOST must be set`);
}
let apiHost = process.env.REACT_APP_API_HOST;

if (!apiHost.startsWith("http://") && !apiHost.startsWith("https://")) {
  // Prepend https:// if missing
  apiHost = `https://${apiHost}`;
}

export const { axios, noAuthAxios } = axiosApi.createAxiosInstances(apiHost);
